<div class="input-field mt-2">
    <label for="name">Serie</label>
    <p-dropdown name="transactionSerieId" [options]="transactionSeries" optionLabel="name" optionValue="id"
        [filter]="true" filterBy="name" placeholder="Seleccione serie" appendTo="body"          
        [(ngModel)]="invoice.transactionSerieId" d-form-field-error/>
</div> 
<div class="input-field mt-2" *ngIf="invoice.transactionSerieId == -1">
    <label for="code">Código</label>
    <input pInputText placeholder="Ingrese código manualmente" [(ngModel)]="invoice.code" name="code"
        class="w-full" />
</div> 
<div class="input-field mt-2">        
    <label for="date">Fecha</label>
    <p-calendar [firstDayOfWeek]="1" id="date" [(ngModel)]="invoice.date" [showIcon]="true" [showButtonBar]="true"
        [monthNavigator]="true" [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error (ngModelChange)="onInvoiceDateChange($event)" 
        appendTo="body"></p-calendar>
</div>   
<div class="input-field mt-2">
    <label for="paymentMethodId">Forma de pago</label>
    <p-dropdown name="paymentMethodId" [options]="paymentsMethods" optionLabel="name" optionValue="id"
        [filter]="true" filterBy="name" placeholder="Seleccione forma de pago" appendTo="body"
        (onChange)="onPaymentMethodChange($event.value)" 
        [(ngModel)]="invoice.paymentMethodId" d-form-field-error />
</div> 
<div class="input-field mt-2">
    <label for="date">Fecha de vencimiento</label>
    <p-calendar [firstDayOfWeek]="1" [(ngModel)]="invoice.paymentDuedate" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
        [yearNavigator]="true" dateFormat="dd/mm/yy"  d-form-field-error appendTo="body"></p-calendar>
</div>
<div class="input-field mt-2" *ngIf="selectedPaymentMethodRequiresBank">
    <label for="billingCompanyBankAccountId">Cuenta bancaria</label>
    <p-dropdown name="billingCompanyBankAccountId" [options]="billingCompaniesBanksAccounts"
        optionLabel="accountNumber" optionValue="id" [filter]="true" filterBy="accountNumber" [(ngModel)]="invoice.billingCompanyBankAccountId"
        placeholder="Seleccione cuenta bancaria" appendTo="body" 
        d-form-field-error />
</div>
<div class="input-field mt-2">
    <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox [(ngModel)]="invoice.isPayed" [binary]="true" value="true" />Marcar cómo pagadas</label>
</div> 

<div class="pt-3" style="font-size: 14px;">
    <div><b>SubTotal:</b>&nbsp;&nbsp;{{ subtotalTransactionsSelected | currency:'EUR':'symbol':'1.2-2' }} </div>
    <div><b>Total:</b>&nbsp;&nbsp;&nbsp;{{ totalTransactionsSelected | currency:'EUR':'symbol':'1.2-2' }}</div>
    <div><b>Total seleccionados:</b>&nbsp;&nbsp;&nbsp;{{ transactions.length }}</div>
</div>
<div class="mt-4 flex justify-content-end gap-2">
    <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="close()"></button>
    <button pButton label="Generar factura" icon="pi pi-check" (click)="generateInvoice()"></button>
</div>